export default {
  setErrorCode(context, errorCode) {
    context.commit("setErrorCode", errorCode);
  },
  setRedirect(context, redirect) {
    context.commit("setRedirect", redirect);
  },
  setErrorType(context, errorType){
    context.commit("setErrorType", errorType);
  }
};
